export default __webpack_public_path__ + "static/media/gamitar-logo.1f7bb6fb.svg";